import CryptoJS from 'crypto-js';

export const generateCacheKey = (query, variables, options = {}) => {
    const variablesString = JSON.stringify(variables);
    const optionsString = JSON.stringify(options);
    return CryptoJS.SHA3(`${variablesString}-${optionsString}`, { outputLength: 512 }).toString(CryptoJS.enc.Hex);
}